export const sortMethods = {
  alphabetical: (a, b) => b.localeCompare(a),
  number: (a, b) => b - a,
  date: (a, b) => new Date(b).getTime() - new Date(a).getTime(),
  alert: (a, b) =>
    ["EMERGENCY", "CRITICAL", "WARNING", "INACTIVE", "NONE"].indexOf(a.trim()) -
    ["EMERGENCY", "CRITICAL", "WARNING", "INACTIVE", "NONE"].indexOf(b.trim()),
  group: (a, b) => (a == null ? 1 : b == null ? -1 : b.localeCompare(a)),
};
